import { KBIT2ParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const KBIT_2_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: KBIT2ParsedResult,
  sections: [
    {
      type: "text_field",
      key: "Date of Testing",
      label: "Date of Testing",
      editable: true,
      validation: { inputType: "date" },
    },
    {
      type: "text_field",
      key: "Age at Testing",
      label: "Age at Testing",
      editable: true,
    },
    {
      type: "text_field",
      key: "Examiner Name",
      label: "Examiner Name",
      editable: true,
    },
    {
      type: "score_table",
      label: "Standard Score Summary",
      source: "Standard Score Summary",
      columns: [
        { key: "Composite", label: "Composite", editable: false },
        {
          key: "Standard Score",
          label: "Standard Score",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Percentile Rank",
          label: "Percentile Rank",
          editable: true,
        },
        {
          key: "Percentile Rank Confidence Interval",
          label: "Percentile Rank CI",
          editable: true,
        },
        {
          key: "Confidence Interval",
          label: "Confidence Interval",
          editable: true,
        },
        {
          key: "Descriptive Category",
          label: "Descriptive Category",
          editable: true,
        },
      ],
    },
    {
      type: "score_table",
      label: "Subtest Score Summary",
      source: "Subtest Score Summary",
      columns: [
        { key: "Subtest", label: "Subtest", editable: false },
        {
          key: "Raw Score",
          label: "Raw Score",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Scaled Score",
          label: "Scaled Score",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Age Equivalent",
          label: "Age Equivalent",
          editable: true,
        },
      ],
    },
    {
      type: "score_table",
      label: "Score Comparisons",
      source: "Score Comparisons",
      columns: [
        {
          key: "Comparison Type",
          label: "Comparison Type",
          editable: false,
        },
        { key: "Measure A Label", label: "Measure A", editable: false },
        {
          key: "Measure A Score",
          label: "Score A",
          editable: true,
          validation: { inputType: "number" },
        },
        { key: "Measure B Label", label: "Measure B", editable: false },
        {
          key: "Measure B Score",
          label: "Score B",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Difference",
          label: "Difference",
          editable: true,
          validation: { inputType: "number" },
        },
        {
          key: "Significance of Difference",
          label: "Significance of Difference",
          editable: true,
        },
        {
          key: "Frequency of Occurrence",
          label: "Frequency of Occurrence",
          editable: true,
        },
      ],
    },
  ],
};
